import { __awaiter } from "tslib";
import { FilterTree, getFieldValueFromItem } from "./SmartTableFilter";
import { IntegratedDialog } from "@tedivo/tedivo-ui";
import { assertNonNullish } from "@tedivo/tedivo-pure-helpers";
import { removeChildren } from "@tedivo/tedivo-dom-helpers";
/* eslint-disable @typescript-eslint/no-unused-vars */
export class SmartTableFiltersMgmt {
    constructor(labels, parentNode, listOfSavedFilters, fieldsByKey, userOptionsStorage, onChangeFilter) {
        this.labels = labels;
        this.listOfSavedFilters = listOfSavedFilters;
        this.fieldsByKey = fieldsByKey;
        this.userOptionsStorage = userOptionsStorage;
        this.onChangeFilter = onChangeFilter;
        this._currentEditingFilterId = undefined;
        this._editNameInput = undefined;
        this._deleteButton = undefined;
        this._saveButton = undefined;
        this.changeNameInDB = () => {
            if (!this._editNameInput || !this.userOptionsStorage || !this._saveButton)
                return;
            // Handle name change
            const newName = this._editNameInput.value.trim();
            if (this.validateNameString(newName)) {
                const existingFilter = this.listOfSavedFilters.find((filter) => filter.id === this.currentEditingFilterId);
                if (existingFilter) {
                    this._saveButton.disabled = true;
                    this._saveButton.loading = true;
                    this.userOptionsStorage
                        .storeFilterTree(existingFilter.filterDefinition, existingFilter.id, String(newName), existingFilter.scope)
                        .then(() => __awaiter(this, void 0, void 0, function* () {
                        yield this._updateListOfFiltersInRadioGroup();
                        this._radioButtonsList.value = existingFilter.id;
                        this.onChangeFilter(this.listOfSavedFilters);
                    }))
                        .finally(() => {
                        if (!this._saveButton)
                            return;
                        this._saveButton.disabled = false;
                        this._saveButton.loading = false;
                    });
                }
            }
            else {
                this.validateNameUI();
            }
        };
        this.validateNameString = (newName) => {
            if (!newName)
                return false;
            if (newName.length < 3)
                return false;
            if (newName.length > 50)
                return false;
            newName = newName.trim();
            if (!newName)
                return false;
            return this.listOfSavedFilters.every((filter) => filter.name.toUpperCase() !== newName.toUpperCase() ||
                filter.id === this.currentEditingFilterId);
        };
        this.validateNameUI = () => {
            if (!this._editNameInput || !this._saveButton)
                return;
            const isUnique = this.validateNameString(this._editNameInput.value);
            if (!isUnique) {
                this._editNameInput.classList.add("has-error");
                this._saveButton.disabled = true;
            }
            else {
                this._editNameInput.classList.remove("has-error");
                this._saveButton.disabled = false;
            }
        };
        this.removeFIlterDB = () => {
            if (!this.userOptionsStorage || !this._deleteButton)
                return;
            this._deleteButton.disabled = true;
            this._deleteButton.loading = true;
            const selectedFilter = this.listOfSavedFilters.find((filter) => filter.id === this.currentEditingFilterId);
            if (selectedFilter) {
                this.userOptionsStorage
                    .removeFilterTree(selectedFilter.id)
                    .then(() => __awaiter(this, void 0, void 0, function* () {
                    yield this._updateListOfFiltersInRadioGroup();
                    this._radioButtonsList.value = "";
                    this.currentEditingFilterId = undefined;
                    this.onChangeFilter(this.listOfSavedFilters);
                }))
                    .finally(() => {
                    if (!this._deleteButton)
                        return;
                    this._deleteButton.disabled = false;
                    this._deleteButton.loading = false;
                });
            }
        };
        this._updateListOfFiltersInRadioGroup = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const newList = yield ((_a = this.userOptionsStorage) === null || _a === void 0 ? void 0 : _a.fetchAllFilterTrees());
            if (newList) {
                this.listOfSavedFilters = newList.sort((a, b) => a.name.localeCompare(b.name));
                removeChildren(this._radioButtonsList);
                this.listOfSavedFilters.forEach((filter) => {
                    const radioButton = document.createElement("sl-radio");
                    radioButton.value = filter.id;
                    radioButton.innerHTML = filter.name;
                    this._radioButtonsList.appendChild(radioButton);
                });
            }
        });
        assertNonNullish(userOptionsStorage, "userOptionsStorage is required");
        this._dialog = new IntegratedDialog({
            parentNode,
            width: "1100px",
            maxWidth: "90vw",
            bodyOverflow: "auto",
            removeDialogWhenHidden: true,
            buttonsAttrs: [
                {
                    value: "close",
                    label: this.labels.close,
                    variant: "text",
                    type: "submit",
                },
            ],
        });
        const holder = document.createElement("div");
        holder.className = "saved-filters-holder";
        const divListOfSavedFilters = document.createElement("div");
        divListOfSavedFilters.className = "saved-filters-list";
        const divMiddle = document.createElement("div");
        divMiddle.className = "saved-filters-middle";
        const divEdit = document.createElement("div");
        divEdit.className = "saved-filters-edit";
        const divShowConditionsHtml = document.createElement("div");
        divShowConditionsHtml.className = "saved-filters-explain";
        const radioButtonsList = document.createElement("sl-radio-group");
        this._radioButtonsList = radioButtonsList;
        listOfSavedFilters.forEach((filter) => {
            const radioButton = document.createElement("sl-radio");
            radioButton.value = filter.id;
            radioButton.innerHTML = filter.name;
            radioButtonsList.appendChild(radioButton);
        });
        divListOfSavedFilters.appendChild(radioButtonsList);
        holder.appendChild(divListOfSavedFilters);
        holder.appendChild(divMiddle);
        divMiddle.appendChild(divEdit);
        divMiddle.appendChild(divShowConditionsHtml);
        this._dialog.show(this.labels.manageFilters, holder);
        this._divEdit = divEdit;
        this._showConditionsHtml = divShowConditionsHtml;
        this._divMiddle = divMiddle;
        this.attachEvents();
    }
    get currentEditingFilterId() {
        return this._currentEditingFilterId;
    }
    set currentEditingFilterId(value) {
        this._currentEditingFilterId = value;
        if (value) {
            this._divMiddle.setAttribute("data-filter-id", value);
        }
        else {
            this._divMiddle.removeAttribute("data-filter-id");
        }
    }
    attachEvents() {
        this._radioButtonsList.addEventListener("sl-change", (e) => {
            const target = e.target;
            const selectedFilterId = target.value;
            this.showNameEditOrDelete(selectedFilterId);
        });
    }
    showNameEditOrDelete(selectedFilterId) {
        if (!selectedFilterId)
            return;
        const selectedFilter = this.listOfSavedFilters.find((filter) => filter.id === selectedFilterId);
        if (selectedFilter) {
            // Show edit name or delete button
            this.currentEditingFilterId = selectedFilterId;
            if (!this._editNameInput || !this._deleteButton) {
                this._editNameInput = document.createElement("sl-input");
                this._editNameInput.label = this.labels.editName;
                this._editNameInput.value = selectedFilter.name;
                this._editNameInput.placeholder = selectedFilter.name;
                this._editNameInput.helpText = this.labels.filterNameUnique;
                this._editNameInput.addEventListener("sl-input", this.validateNameUI);
                const iconSave = document.createElement("sl-icon");
                iconSave.name = "box-arrow-in-down";
                iconSave.slot = "prefix";
                this._saveButton = document.createElement("sl-button");
                this._saveButton.innerHTML = this.labels.saveChange;
                this._saveButton.variant = "primary";
                this._saveButton.appendChild(iconSave);
                this._saveButton.addEventListener("click", this.changeNameInDB);
                const icon = document.createElement("sl-icon");
                icon.name = "trash";
                icon.label = this.labels.deleteFilter;
                icon.slot = "prefix";
                this._deleteButton = document.createElement("sl-button");
                this._deleteButton.innerHTML = this.labels.deleteFilter;
                this._deleteButton.variant = "danger";
                this._deleteButton.appendChild(icon);
                this._deleteButton.addEventListener("click", this.removeFIlterDB);
                const spacer = document.createElement("div");
                spacer.className = "spacer";
                this._divEdit.appendChild(this._editNameInput);
                this._divEdit.appendChild(this._saveButton);
                this._divEdit.appendChild(spacer);
                this._divEdit.appendChild(this._deleteButton);
            }
            else {
                this._editNameInput.classList.remove("has-error");
                this._editNameInput.value = selectedFilter.name;
                this._editNameInput.placeholder = selectedFilter.name;
            }
            removeChildren(this._showConditionsHtml);
            const filterTree = new FilterTree({
                labels: this.labels,
                filterTree: selectedFilter.filterDefinition,
                fieldsByKey: this.fieldsByKey,
            });
            const filterText = filterTree.toPrettyHtmlElement((field) => { var _a; return ((_a = this.fieldsByKey.get(field)) === null || _a === void 0 ? void 0 : _a.label) || String(field); }, (value, field) => getFieldValueFromItem(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            { [field]: value }, field, this.fieldsByKey), {
                inline: true,
            });
            this._showConditionsHtml.appendChild(filterText);
        }
    }
}
